import { Component, Inject, ViewChild } from '@angular/core';
import {MatDialogRef,MAT_DIALOG_DATA,MatDialog } from '@angular/material/dialog';
import { DialogWrapperComponent } from '../wrappers/dialog-wrapper.component';
import { ImageType, JoiFile } from 'globals/store/files.model';
import { SliderImage } from 'globals/store/publish.data';
import { createId, jsonCopyObject } from 'globals/helpers/helpers';
import { openConfirmDeleteGetResult } from '../dialog.confirmDelete.component';
import { ImageUploaderResult } from 'globals/store/share.data';
import { EditLinkComponent } from '../misc/edit-link.component';
import { TitleIconComponent } from '../icon/title-icon.component';
import { BrandImageTextAdderComponent } from './brand-image-text-adder.component';
import { SliderImageComponent } from './slider-image.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'slider-image-dialog',
    template: `
<dialog-wrapper
  [backgroundColor]="'#11b8c1'"
  [successLabel]="'DONE'"
  [disabled]="false"
  [dontResize]="true"
  [fitContent]="true"
  [dialogTitle]="'Slider Image'"
  [deleteLeft]="true"
  (submit)="done()"
  (cancel)="dialogRef.close(null)"
  (delete)="delete($event)"
>
  <div class="description">Add slider image to your homepage</div>
  <slider-image *ngIf="sliderImage.imageUrl" [sliderImage]="sliderImage"></slider-image>
  <brand-image-text-adder 
    [maxMegs]="1" 
    [width]="360" 
    [height]="300"
    [accountId]="data.accountId"
    [eventId]="data.eventId || null"
    [uniqueFormIdentifier]="'slider'"
    [imageType]="data.imageType"
    [uploadText]="'UPLOAD SLIDER IMAGE'"
    (addImage)="changeImage($event)"
  ></brand-image-text-adder>
  <edit-link [link]="sliderImage.linkUrl" [placeholder]="'Image link...'" (saveLink)="sliderImage.linkUrl = $event;">
    <title-icon [titleIcon]="'link12'" [title]="'Image Link'"></title-icon>
  </edit-link>
</dialog-wrapper>
  `,
    styles: [`
  brand-image-text-adder { margin: 20px 0; }  
  slider-image { margin-top: 20px; }
`],
    standalone: true,
    imports: [EditLinkComponent, DialogWrapperComponent, TitleIconComponent, BrandImageTextAdderComponent, SliderImageComponent, CommonModule],
})
export class SliderImageDialogComponent {
  @ViewChild(DialogWrapperComponent) dialogWrapper : DialogWrapperComponent
  sliderImage: SliderImage
  id = createId()

  constructor(
    public dialogRef: MatDialogRef<SliderImageDialogComponent>, 
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: SliderImageDialogData
  ) {
    this.sliderImage = data.sliderImage ? jsonCopyObject(data.sliderImage) : {
      linkUrl: '',
      imageUrl: ''
    }
  }

  done() {
    const result = !this.data.sliderImage || JSON.stringify(this.data.sliderImage) !== JSON.stringify(this.sliderImage) ? this.sliderImage : null
    this.dialogRef.close(result)
  }

  changeImage(result: ImageUploaderResult) {
    this.sliderImage.imageUrl = result.photoUrl
    this.id = createId()
  }

  resizeDialog() {
    this.dialogWrapper.fitChildrenWithDelay(100)
  }

  async delete(event) {
    const data = {
      title: "Delete slider image",
      para: "This action cannot be undone",
      dialog: this.dialog,
      rect: event.target.getBoundingClientRect(),
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    this.dialogRef.close({ delete: true })
  }

}

export interface SliderImageDialogData {
  sliderImage: SliderImage
  imageType: ImageType
  accountId: string
  eventId?: string
}